import { Component, Inject, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ISubscription } from 'rxjs/Subscription';
import { SharedService } from '../common/shared.service';
import { Title, DOCUMENT } from '@angular/platform-browser';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { PortalService } from '../services/portal.service';
import { ActivatedRoute } from '@angular/router';
//import { SafeHtmlPipe } from '../pipe/safe-html.pipe';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: January 24th 2018
 * 
 * Description: Component class for home - index
 **/
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  lang: string; 
  languageId: any;
  subscriptionLang: ISubscription;
  paramSub: ISubscription;
  alertData: any;
  alertEnText: string;
  alertMyText: string;

  constructor(
    //public safeHtml: SafeHtmlPipe,
    @Inject(DOCUMENT) private document: any,
    private activateRoute: ActivatedRoute, 
    private pageTitle: Title,
    private sharedService: SharedService,
    private translate: TranslateService) { 
        
    this.paramSub = this.activateRoute.queryParams.subscribe(params => {
      let lang = params['language'];
      if (lang === 'EN') {
        this.translate.setDefaultLang('en');
        this.translate.use('en');
        this.document.documentElement.lang = 'en-US';
      } else if (lang === 'MY') {
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
        this.document.documentElement.lang = 'ms-MY';
      }
    });
   
    this.lang = translate.currentLang;
    this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = this.translate.currentLang;

      if (myLang === 'en') {
         this.lang = 'en';
         this.languageId = 1;
      }
      if (myLang === 'ms') {
        this.lang = 'ms';
        this.languageId = 2;
      }

      this.pageTitle.setTitle(this.translate.instant('pageTitle.home')+this.translate.instant('pageTitle.homedesc'));
    }); 
  }

  ngOnInit() {
    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }
     //this.sharedService.showError('testing','');
  }

  ngAfterViewInit() {
    this.translate.get('pageTitle.home').subscribe((title:string)=>{
      title = this.translate.instant('pageTitle.home')+this.translate.instant('pageTitle.homedesc');
      this.sharedService.setTitleAndGtag(title);
    });
    if (!this.sharedService.isMaintenanceShown.getValue()) {
      this.getMaintainanceAlert();
    }
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.paramSub.unsubscribe();
  }
  
  getMaintainanceAlert() {
    //this.loading = true;
   
    this.sharedService.getLatestAnnouncement(this.languageId, 'maintenance').
    subscribe(data => {
      //this.loading = false;
      this.alertData = data;
      if (this.alertData.statusCode == 'SUCCESS') {
        //console.log(this.alertData.list[0].list);
        if (this.alertData.announcement) {
      
          if (this.languageId == 1) {
            this.alertEnText = this.alertData.announcement.announcementText;
            this.sharedService.showAnnouncement(this.alertEnText,''); 
          } else if (this.languageId == 2) {
            this.alertMyText = this.alertData.announcement.announcementText;
            this.sharedService.showAnnouncement(this.alertMyText,''); 
          }

          this.sharedService.isMaintenanceShown.next(true);

        }
      } 
    },
    Error => {
      //this.loading = false;        
   });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts